import React from 'react'
import icoEliminar from "../../Img/Iconos/eliminar.svg"
import "./styles/PerfilCard.scss";
import { deleteCedula_request } from "../../services/perfil_services";
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { DeleteOutline } from '@mui/icons-material';


const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


export default function PerfilCard({ cedulas, eliminarCedula }) {
  return (
    cedulas.map((cedula) => (
      <div className='PerfilCardContainer'>
        <div>
          <label htmlFor=""><b>Cédula: {cedula.Cedula ?? ""}</b></label>
          <p>{cedula.Profesion}</p>
        </div>
        <div>
          <i cid={cedula.cedula}>
            {/* <img src={icoEliminar} alt="" onClick={
              () => eliminarCedula(cedula.IdUserProfesion)
            } /> */}
            <DeleteOutline style={{ color: "grey" }} onClick={
              () => eliminarCedula(cedula.IdUserProfesion)
            } />
          </i>
        </div>
      </div>
    ))
  )
}

